import formatDollar from '@lib/utils/format-dollar'

const TABLE_COLUMNS = [
  {
    name: 'created_at',
    label: 'Date',
    format: 'dateTime',
    icon: 'el-icon-document',
  },
  {
    name: 'description',
    label: 'Description',
    icon: 'el-icon-document',
  },
  {
    name: 'amount.total',
    label: 'Total',
    icon: 'el-icon-document',
    format: (value, row, component) => {
      const { ewalletReference } = component
      const { payment_source: { id } } = row

      if (id === ewalletReference) {
        return formatDollar(-value)
      } else {
        return formatDollar(value)
      }
    },
  },
]

export default component => ({
  processor: null,
  columns: TABLE_COLUMNS,
  tableName: 'claim-transactions',
})
